import React, { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import { CustomerLaws } from './CustomerLaws/CustomerLaws.List';
import { AddCustomerLaws } from './CustomerLaws/CustomerLaws.Add';
import { EditCustomerLaw } from './CustomerLaws/CustomerLaw.Edit';
import { UpdateCustomerLaws } from './CustomerLaws/CustomerLaws.Update';
import { AddLawCompanyUnit, EditLawCompanyUnit } from './CustomerLaws/CompanyUnits/LawCompanyUnits.Edit';
import { EditOrganizationLawPortalChecklist } from './CustomerLaws/CompanyUnits/Checklist/Checklist.Edit';
import { OtherRequirements } from './OtherRequirements/CustomerRequirements.List';
import { NewRequirement } from './OtherRequirements/CustomerRequirement.Create';
import { EditRequirement } from './OtherRequirements/CustomerRequirement.Edit';
import {
  AddRequirementCompanyUnit,
  EditRequirementCompanyUnit,
} from './OtherRequirements/CompanyUnits/RequirementCompanyUnits.Edit';
import { EditRequirementChecklist } from './OtherRequirements/CompanyUnits/Checklist';
import {
  UserContext,
  LawPortalFeature,
  AccessLevel,
} from '../../../../Context/UserContext/UserContext';

export const LawPortal = () => {
  const { hasAccessToFeature } = useContext(UserContext);
  const canManage = hasAccessToFeature(LawPortalFeature.Manage, AccessLevel.Manage);
  const accessToOurLaws = hasAccessToFeature(LawPortalFeature.OurLaws, AccessLevel.Read);
  const accessToOtherRequirements = hasAccessToFeature(LawPortalFeature.OtherRequirements, AccessLevel.Read);

  return (
    <Routes>
      {canManage && accessToOurLaws && (
        <Route path="laws/:lawid/company-units/new" element={<AddLawCompanyUnit />} />
      )}
      {canManage && accessToOurLaws && (
        <Route
          path="laws/:lawid/company-units/:unitid/checklist"
          element={<EditOrganizationLawPortalChecklist />}
        />
      )}
      {canManage && accessToOurLaws && (
        <Route
          path="laws/:lawid/company-units/:unitid"
          element={<EditLawCompanyUnit />}
        />
      )}
      {canManage && accessToOurLaws && (
        <Route path="laws/new" element={<AddCustomerLaws />} />
      )}
      {accessToOurLaws && (
        <Route
          path="laws/update-for-company-unit/:unitid"
          element={<UpdateCustomerLaws />}
        />
      )}
      {canManage && accessToOurLaws && (
        <Route path="laws/:lawid" element={<EditCustomerLaw />} />
      )}
      {accessToOurLaws && (
        <Route path="laws" element={<CustomerLaws />} />
      )}

      {canManage && accessToOtherRequirements && (
        <Route
          path="other-requirements/:reqid/company-units/new"
          element={<AddRequirementCompanyUnit />}
        />
      )}
      {canManage && accessToOtherRequirements && (
        <Route
          path="other-requirements/:reqid/company-units/:unitid/checklist"
          element={<EditRequirementChecklist />}
        />
      )}
      {canManage && accessToOtherRequirements && (
        <Route
          path="other-requirements/:reqid/company-units/:unitid"
          element={<EditRequirementCompanyUnit />}
        />
      )}
      {canManage && accessToOtherRequirements && (
        <Route path="other-requirements/new" element={<NewRequirement />} />
      )}
      {canManage && accessToOtherRequirements && (
        <Route path="other-requirements/:reqid" element={<EditRequirement />} />
      )}
      {accessToOtherRequirements && (
        <Route path="other-requirements" element={<OtherRequirements />} />
      )}
    </Routes>
  );
};

